var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 47,
    viewBox: "0 0 125 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.215 32.4641H83.8716C83.3905 32.4641 83 32.0736 83 31.5925V27.4515C83 26.9698 83.3905 26.58 83.8716 26.58H102.215C102.696 26.58 103.087 26.9698 103.087 27.4515V31.5925C103.087 32.0736 102.697 32.4641 102.215 32.4641Z",
    fill: "#E9E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2154 19.8841H0.871551C0.390455 19.8841 0 19.4937 0 19.0126V14.8716C0 14.3899 0.390455 14 0.871551 14H19.2154C19.6965 14 20.0869 14.3899 20.0869 14.8716V19.0126C20.0869 19.4937 19.697 19.8841 19.2154 19.8841Z",
    fill: "#E9E7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.128 32.4641H105.785C105.304 32.4641 104.913 32.0736 104.913 31.5925V27.4515C104.913 26.9698 105.304 26.58 105.785 26.58H124.128C124.61 26.58 125 26.9698 125 27.4515V31.5925C125 32.0736 124.61 32.4641 124.128 32.4641Z",
    fill: "#E9E7E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1284 19.8841H22.7846C22.3035 19.8841 21.9131 19.4937 21.9131 19.0126V14.8716C21.9131 14.3899 22.3035 14 22.7846 14H41.1284C41.6101 14 42 14.3899 42 14.8716V19.0126C42 19.4937 41.6101 19.8841 41.1284 19.8841Z",
    fill: "#E9E7E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.172 39.9687H94.8281C94.347 39.9687 93.9565 39.5783 93.9565 39.0972V34.9561C93.9565 34.475 94.347 34.0846 94.8281 34.0846H113.172C113.653 34.0846 114.043 34.475 114.043 34.9561V39.0972C114.043 39.5783 113.654 39.9687 113.172 39.9687Z",
    fill: "#E9E7E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1719 27.3888H11.8281C11.347 27.3888 10.9565 26.9983 10.9565 26.5172V22.3762C10.9565 21.8951 11.347 21.5046 11.8281 21.5046H30.1719C30.653 21.5046 31.0434 21.8951 31.0434 22.3762V26.5172C31.0434 26.9983 30.6536 27.3888 30.1719 27.3888Z",
    fill: "#E9E7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9767 0L104 9.88688H56.1764L46.8316 0H92.9767Z",
    fill: "#407BFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M92.9767 0L104 9.88688H56.1764L46.8316 0H92.9767Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9982 0H46.8316V46.1666H92.9982V0Z",
    fill: "#407BFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M92.9982 0H46.8316V46.1666H92.9982V0Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1679 0H32.0013V46.1666H78.1679V0Z",
    fill: "#7CA3FA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0228 0L21 9.88688H68.8232L78.1679 0H32.0228Z",
    fill: "#407BFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M32.0228 0L21 9.88688H68.8232L78.1679 0H32.0228Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8371 15.9064C60.1408 15.9064 63.0634 18.4437 63.0634 22.6185C63.0634 27.1465 59.852 29.1383 55.5483 29.1383L55.4205 31.6756H52.2405L52.0801 26.6328H53.1399C56.7696 26.6328 59.5638 25.9908 59.5638 22.6185C59.5638 20.3705 58.1827 18.9893 55.8702 18.9893C53.5902 18.9893 52.1452 20.2734 52.1452 22.522H48.709C48.6747 18.6367 51.4694 15.9064 55.8371 15.9064ZM53.7814 38.7735C52.4642 38.7735 51.4369 37.7457 51.4369 36.4297C51.4369 35.1125 52.4648 34.0852 53.7814 34.0852C55.066 34.0852 56.0939 35.113 56.0939 36.4297C56.0945 37.7457 55.0666 38.7735 53.7814 38.7735Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.fec51746a88f6cfa17335784b82eec1a.svg";
export { ForwardRef as ReactComponent };